import { AxiosRequestConfig } from 'axios';
import instance from 'api';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IAvailableColumnModel, IAvailableGroupColumnModel, IPosition } from 'interfaces';
import { ICriteriaRatingUgo, ICriteriaTypeUgo } from './interfaces';

export const getCriteriaRatingUgoList = (data: IDynamicTableParams) => {
  return instance()
    .post<ICriteriaRatingUgo[]>('/defectAct/criteriaRatingUgo/list', data)
    .then((response) => response.data);
};

export const getCriteriaRatingUgoAvailableColumns = () => {
  return instance()
    .post<IAvailableColumnModel[]>('/defectAct/criteriaRatingUgo/availableColumns')
    .then((response) => response.data);
};

export const getCriteriaRatingUgoAvailableGroupColumns = () => {
  return instance()
    .post<IAvailableGroupColumnModel[]>('/defectAct/criteriaRatingUgo/availableGroupColumns')
    .then((response) => response.data);
};

export const loadCriteriaRatingUgo = (criteriaRatingId: number) => {
  return instance()
    .get<ICriteriaRatingUgo>(`/defectAct/criteriaRatingUgo/load/${criteriaRatingId}`)
    .then((response) => response.data);
};

export const createCriteriaRatingUgo = (criteriaRatingUgo: ICriteriaRatingUgo) => {
  return instance()
    .post<ICriteriaRatingUgo>('/defectAct/criteriaRatingUgo/save', criteriaRatingUgo)
    .then((response) => response.data);
};

export const updateCriteriaRatingUgo = (criteriaRatingUgo: ICriteriaRatingUgo) => {
  return instance()
    .post<ICriteriaRatingUgo>(
      `/defectAct/criteriaRatingUgo/update/${criteriaRatingUgo.criteriaRatingId}`,
      criteriaRatingUgo,
    )
    .then((response) => response.data);
};

export const deleteCriteriaRatingUgo = (criteriaRatingId: number) => {
  return instance()
    .post(`/defectAct/criteriaRatingUgo/archive/${criteriaRatingId}`)
    .then((response) => response.data);
};

export const recoverCriteriaRatingUgo = (criteriaRatingId: number) => {
  return instance()
    .post(`/defectAct/criteriaRatingUgo/recover/${criteriaRatingId}`)
    .then((response) => response.data);
};

export const getCriteriaRatingUgoListPosition = (config?: AxiosRequestConfig) => {
  return instance()
    .get<IPosition[]>(`/defectAct/criteriaRatingUgo/listPositions`, config)
    .then((response) => response.data);
};

export const getCriteriaTypeUgoList = () => {
  return instance()
    .post<ICriteriaTypeUgo[]>(`/dictionary/defectAct/criteriaTypeUgo`)
    .then((response) => response.data);
};
